module.exports = __webpack_public_path__ + "fonts/Simple-Line-Icons.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/simple-line-icons/fonts/Simple-Line-Icons.woff2?v=2.4.0
// module id = 1642
// module chunks = 1